import React from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import NavbarService from './NavbarService';

const SERVICE_ROUTES = [
  { prefix: '/vtc',         service: 'vtc' },
  { prefix: '/logistics',   service: 'logistics' },
  { prefix: '/courses',     service: 'courses' },
  { prefix: '/carpool',     service: 'carpool' },
  { prefix: '/car-rental',  service: 'car-rental' },
];

const NO_NAV_PREFIXES = [
  '/partner/',
  '/delivery/dashboard',
  '/admin',
  '/restaurants',
  '/restaurant',
];

export default function NavbarConditional() {
  const { pathname } = useLocation();

  if (NO_NAV_PREFIXES.some(p => pathname.startsWith(p))) return null;

  const match = SERVICE_ROUTES.find(r => pathname.startsWith(r.prefix));
  if (match) return <NavbarService service={match.service} />;

  return <Navbar />;
}
